import { gql } from 'graphql-request'

export const checkIn = gql`
  query CheckIn($checkInId: String!) {
    checkin(id: $checkInId) {
      clientId
      datetime
      status
      failReason
      payments {
        outstanding {
          label
          price
          currency
          siteName
          datetime
          v1InvoiceId
          v1PaymentMasterId
          v1PaymentType
        }
        failed {
          label
          price
          currency
          siteName
          datetime
          v1InvoiceId
        }
      }
      membership {
        title
      }
      nextSession {
        title
        datetime
      }
      client {
        id
        firstName
        lastName
        birthday
        profileImage {
          url
        }
        formsPending {
          siteId
          title
        }
        totalCheckInCount
        siteInformation {
          siteId
          lastCheckInOn
          checkInCount
        }
        v1Id
        homeLocationIds
        siteNotes {
          siteId
        }
        siteAlertedProperties {
          siteId
        }
        sitesInIntroOffer
      }
      id
      homeSiteName
    }
  }
`

export const checkIns = gql`
  query CheckIns($siteId: ID!, $cursor: String, $pageSize: Float!) {
    checkIns(siteId: $siteId, after: $cursor, pageSize: $pageSize) {
      pageInfo {
        endCursor
        hasNextPage
      }
      items {
        checkInId
        clientId
        siteId
        type
        status
        source
        dateTime
        failReason
        createdAt
        failedInvoices {
          invoiceId
          amount
          dueDate
          description
        }
        stagedInvoices {
          invoiceId
          amount
          dueDate
          description
        }
        client {
          id
          firstName
          lastName
          dateOfBirth
          homeSiteId
          homeSiteName
          homeLocationIds
          notes
          profileImage(input: { format: webp, type: thumbnail }) {
            url
          }
          totalCheckInCount
          siteInformation {
            siteId
            lastCheckInOn
            checkInCount
          }
        }
        nextSession {
          sessionId
          sessionName
          sessionDateTime
        }
        service {
          serviceId
          serviceName
          serviceType
          creditsRemaining
        }
        site {
          siteId
          name
        }
      }
    }
  }
`

export const getLatestTanningCheckIn = gql`
  query GetLatestTanningCheckIn($clientId: ID!, $siteId: ID!) {
    latestTanningCheckIn(clientId: $clientId, siteId: $siteId) {
      checkInId
      clientId
      siteId
      type
      status
      dateTime
    }
  }
`

// Legacy query for backward compatibility (will be removed after full migration)
export const checkInsLegacy = gql`
  query CheckIns($siteId: String!, $paginate: PaginationInput) {
    checkins(siteId: $siteId, paginate: $paginate) {
      pageInfo {
        endCursor
        hasNextPage
      }
      results {
        node {
          clientId
          datetime
          status
          failReason
          payments {
            outstanding {
              label
              price
              currency
              siteName
              datetime
              v1InvoiceId
              v1PaymentMasterId
              v1PaymentType
            }
            failed {
              label
              price
              currency
              siteName
              datetime
              v1InvoiceId
            }
          }
          membership {
            title
          }
          nextSession {
            title
            datetime
          }
          client {
            id
            firstName
            lastName
            birthday
            homeSites
            profileImage {
              url
            }
            formsPending {
              siteId
              title
            }
            v1Id
            totalCheckInCount
            siteInformation {
              siteId
              lastCheckInOn
              checkInCount
            }
            siteNotes {
              siteId
            }
            siteAlertedProperties {
              siteId
            }
            sitesInIntroOffer
          }
          id
          homeSiteName
        }
      }
    }
  }
`
